import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import i18n from "i18next";
import { GOOGLE_MAP_KEY } from "../../constants";

const AnyReactComponent = ({ text }) => (
  <img alt="" src="https://www.chowsangsang.com/en/img/ui/pin-active.png" />
);

const createMapOptions = maps => {
  return {
    panControl: true,
    mapTypeControl: true,
    streetViewControl: true,
    styles: [
      {
        stylers: [{ visibility: "on" }]
      }
    ]
  };
};

class SimpleMap extends Component {
  render() {
    const { dsLatitude, dsLongitude } = this.props;
    const center = {
      lat: parseFloat(dsLatitude),
      lng: parseFloat(dsLongitude)
    };
    const zoom = 18;
    const lang = i18n.language;
    return (
      // Important! Always set the container height explicitly
      <div
        style={{ height: "522px", width: "100%" }}
        className="google-map-height"
      >
        <GoogleMapReact
          bootstrapURLKeys={{
            key: GOOGLE_MAP_KEY,
            language: lang === "en" ? "en" : "zh_HK"
          }}
          defaultCenter={center}
          defaultZoom={zoom}
          options={createMapOptions}
        >
          <AnyReactComponent lat={dsLatitude} lng={dsLongitude} text="Here" />
        </GoogleMapReact>
      </div>
    );
  }
}

export default SimpleMap;
